import {ILanguageConfiguration} from "../interfaces/languageConfiguration.interface.ts";
import {IStepperStep} from "../interfaces/steperItem.interface.ts";

export const ONE_SECONDS_IN_ML = 1000
export const ONE_MINUTE_IN_ML = 60 * ONE_SECONDS_IN_ML


export type SUPPORTED_FILE_TYPES = "wmv" | "avi" | "mp4" | "mkv" | "mov"
export const ALLOWED_TYPES: Record<string, SUPPORTED_FILE_TYPES> = {
  "video/x-ms-wmv": "wmv",
  "video/x-msvideo": "avi",
  "video/mp4": "mp4",
  "video/x-matroska": "mkv",
  "video/quicktime": "mov",
};


export const CREATE_NEW_PROJECT_STEPS: IStepperStep[] = [
  {
    title: 'Upload Files',
    description: 'Upload and name each file'
  },
  {
    title: 'Subtitle',
    description: 'Select and configure subtitles',
  },
  {
    title: 'Metadata',
    description: 'Select and configure metadata',
  },
  {
    title: 'Advanced',
    description: 'Add optional products or services to enhance your project',
  }
];

export const CREATE_NEW_PROJECT_SUBTITLES_STEPS: IStepperStep[] = [
  {
    title: 'Source Language',
    description: 'Select and configure source language'
  },
  {
    title: 'Target Languages',
    description: 'Select and configure target languages'
  },
  {
    title: 'Features',
    description: 'Choose extra features and finalize project(s)'
  },
];

export const CREATE_PROJECT_ADDITIONAL_FEATURES: string[] = [
  "Shot Sync Change",
  "Detect Ad Stops",
  "Auto-Background Subtitles",
];

export const CREATE_PROJECT_ADDITIONAL_FEATURES_MAPPING: Record<string, string> = {
  "shotChangeSync": CREATE_PROJECT_ADDITIONAL_FEATURES[0],
  "detectAdStops": CREATE_PROJECT_ADDITIONAL_FEATURES[1],
  "autoBackgroundSubtitles": CREATE_PROJECT_ADDITIONAL_FEATURES[2],
};


export const LANGUAGE_DEFAULT_CONFIGURATION: ILanguageConfiguration = {
  maxCharactersPerLine: 40,
  minFramesGap: 2,
  maxSubtitleTime: 7,
  maxLines: 2,
  minSubtitleTimeInFrames: 20
}

export const LANGUAGE_CONFIGURATION_BOUNDS: Record<keyof ILanguageConfiguration, { min: number; max: number }> = {
  maxCharactersPerLine: {min: 10, max: 60},
  minFramesGap: {min: 1, max: 10},
  maxSubtitleTime: {min: 1, max: 12},
  maxLines: {min: 1, max: 4},
  minSubtitleTimeInFrames: {min: 1, max: 25},
};

export const GLIX_SHOT_DETECTION_SENSITIVITY_DEFAULT = 0.37